export default [
  {
    label: "Textual",
    value: "textual"
  },
  {
    label: "Visual",
    value: "visual"
  },
  {
    label: "Auditory",
    value: "auditory"
  },
];
